<template>
<div class="container-fluid ">
  <div class="text-center  font-28 pt-10 uptodown">
    <i class=" fa-solid white--text fa-pen-field font-60 "></i>
  </div>
  <h2 class="text-center white--text font-28 uptodown font-30">
    سایر خدمات
  </h2>
  <p class="text-center white--text font-12 lefttoright pb-3">
    خدماتی که در تمامی پروژه های استارتاپی ارائه میشود
  </p>
  <div class="px-16 d-none d-lg-block pb-6 ">
    <div class="row text-center ">
      <div class="col-4 " v-for="(item,i) in services" :key="i" >
        <div class="flip-card-ServiceCard ">
          <div class="flip-card-inner-ServiceCard border rounded righttoleft light ">
            <div class="container flip-card-front-ServiceCard text-center bg-card-service">
              <i :class="item.icons" class="mt-7 font-60"></i>
              <h2 class="mt-10 font-16 bold text-center">{{ item.title }}</h2>
            </div>
            <div class="container flip-card-back-ServiceCard bg-card-service">
              <h2 class="mt-10 font-16 bold text-center">{{ item.title }}</h2>
              <p class="mt-10 px-5 font-14 text-center">{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container d-block d-lg-none righttoleft">
    <div class="">
      <div class="row text-center">
        <div class="col-12 col-lg-4 " v-for="(item,i) in services" :key="i">
              <div class="border Service-height light">
                <div class="text-center">
                  <i :class="item.icons " class="fal fa-alarm-clock font-60 pt-5 card-text"></i>
<!--                  <h4 class="mt-4 white&#45;&#45;text"> {{ item.title }} </h4>-->
                  <h2 class="font-16 mt-3 text-center card-text">{{ item.title }}</h2>
                  <p class="text-center card-text pt-2">
                    {{ item.text }}  </p>
                </div>
              </div>
<!--              <div class=" ">
                <div class="container border ServiceCard-height">
                  <h4 class=" white&#45;&#45;text ">{{ item.title }}</h4>
                  <p class=" white&#45;&#45;text ">
                    {{ item.text }}  </p>
                </div>
              </div>-->
            </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ServiceCard",
  data: () => ({
    services:[]

  }),
  mounted() {
    this.$getText()


    this.services = this.$getServices();


    this.$scrollTop(0)
  },
}
</script>

<style scoped>


</style>